import React, { Fragment, Component } from "react";
import DataTable from "../../Datatable/DataTable";
import DropDown from "../../common/dropDown/dropDown";
import Scatter from "../../../../d3Components/scatterPlot/Scatter";
import ContainerDimensions from "react-container-dimensions";

class MonthlyTable extends Component {
  state = {
    monthly_return_table: false,
    // hamburger options
    selected: "table",
    options: [
      {
        name: "table",
        text: "Table",
      },
      {
        name: "scatterChart",
        text: "Scatter Chart",
      },
    ],
    style: { left: "-150px", right: "20px" },
    Scatter_chart_data: [],
  };

  componentDidMount() {
    const {
      Scatter_chart_data,
      monthly_table_rows,
      monthly_table_rows2,
      monthly_return_table,
    } = this.props;

    this.setState({
      Scatter_chart_data,
      monthly_table_rows,
      monthly_table_rows2,
      monthly_return_table,
    });
  }
  componentWillReceiveProps(nextProps) {
    const {
      Scatter_chart_data,
      monthly_table_rows,
      monthly_table_rows2,
      monthly_return_table,
    } = nextProps;

    this.setState({
      Scatter_chart_data,
      monthly_table_rows,
      monthly_table_rows2,
      monthly_return_table,
    });
  }

  hamburgerHandler = (e) => {
    e.preventDefault();
    if (e.target.name) {
      this.setState({
        selected: e.target.name,
      });
    }
  };
  render() {
    const {
      monthly_table_rows,
      monthly_table_rows2,
      monthly_return_table,
      options,
      style,
      selected,
      Scatter_chart_data,
    } = this.state;
    const {
      model_name,
      monthly_returns_table_heading,
      benchmark_name,
      display_orig_portfolio,
    } = this.props;
    return (
      <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div>
              <h4 className="text-uppercase bold">Monthly returns</h4>
            </div>
            <DropDown
              data={options}
              onclickHandler={this.hamburgerHandler}
              style={style}
            ></DropDown>
          </div>
          {selected === "table" ? (
            <div className="p-3">
              {monthly_return_table &&
              monthly_table_rows2.length == 0 &&
              monthly_table_rows &&
              monthly_table_rows.length > 0 ? (
                <DataTable
                  data={monthly_table_rows}
                  columns={monthly_returns_table_heading}
                  paging={false}
                  searching={false}
                  bInfo={true}
                  ordering={false}
                />
              ) : null}
              {monthly_return_table &&
              monthly_table_rows.length == 0 &&
              monthly_table_rows2 &&
              monthly_table_rows2.length > 0 ? (
                <DataTable
                  data={monthly_table_rows2}
                  columns={monthly_returns_table_heading}
                  paging={false}
                  searching={false}
                  bInfo={true}
                  ordering={false}
                />
              ) : null}
            </div>
          ) : null}
          {Scatter_chart_data.length ? (
            <Fragment>
              {selected === "scatterChart" ? (
                <ContainerDimensions>
                  {({ width }) => (
                    <Fragment>
                      {width > 0 ? (
                        <Scatter
                          id="scatter_02"
                          width={width - 50}
                          height={400}
                          MainData={Scatter_chart_data}
                        />
                      ) : null}
                    </Fragment>
                  )}
                </ContainerDimensions>
              ) : null}
            </Fragment>
          ) : null}
          <Fragment>
            {display_orig_portfolio ? (
              <div>
                <small>
                  <b>* &nbsp;</b>
                  {benchmark_name}
                </small>
              </div>
            ) : null}
            {model_name ? (
              <div>
                <small>
                  <b>+</b>&nbsp;{model_name}
                </small>{" "}
              </div>
            ) : null}
          </Fragment>
        </div>
      </div>
    );
  }
}

export default MonthlyTable;



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/statistics/MonthlyReturns/monthlyTable.jsx